import React from 'react';

const ToursPage = () => (
    <div className='content'>
        <h1>Tours</h1>
        <h3>
            Open Enrollment is now available for the 2022-23 school year.<br/>
            We are offering small group tours (3-4 parents and 1 teacher).
        </h3>
        <h3>
            Tour Dates:<br/>
            Monday, 2/21 2:00pm<br/>
            Saturday, 2/26 10:00am<br/>
        </h3>
        <h3>
            Please <a href="mailto:tracy.littlenest@yahoo.com">email</a> to reserve your spot.
        </h3>
    </div>
);

export default ToursPage;



// WEBPACK FOOTER //
// ./src/components/ToursPage.js